import { render, staticRenderFns } from "./whats-new.vue?vue&type=template&id=6eac4158&scoped=true&"
import script from "./whats-new.vue?vue&type=script&lang=js&"
export * from "./whats-new.vue?vue&type=script&lang=js&"
import style0 from "./whats-new.vue?vue&type=style&index=0&id=6eac4158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac4158",
  null
  
)

export default component.exports